import styled from 'styled-components'

import { rspTheme } from '../../styles/rspTheme'

export const RelatedSolutionsSection = styled.section`
  background-color: ${rspTheme.palette.primary.background};
  padding: 88px 0 48px;

  &.white {
    background-color: transparent;
  }

  .headline {
    color: ${rspTheme.palette.primary.main};
    margin-bottom: 40px;
  }

  @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
    padding: 48px 0 24px;

    .headline {
      margin-bottom: 24px;
    }
  }
`

export const SlideContent = styled.div`
  max-width: 500px;
  padding-right: 40px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  height: 100%;

  .gatsby-image-wrapper {
    height: 40%;
    margin-bottom: 24px;
    flex-shrink: 0;
    padding-bottom: 50%;

    img {
      min-width: 100%;
      min-height: 100%;
      object-fit: cover !important;
    }

    @media (max-width: 1080px) {
      height: 35%;
    }

    @media (max-width: 980px) {
      height: 30%;
      margin-bottom: 18px;
    }
  }

  @media (max-width: ${rspTheme.breakpoints.values.smmd}px) {
    max-height: 500px;
    padding-right: 8px;
  }
`
